<template>
  <!--            Форма авторизации с телефона-->
  <form class="form-vertical authentication-phone" @submit.prevent="loginByPhone($event)">
    <!--        @click="$emit('recaptcha')"-->
    <DefPhone
      :placeholder="messages.phone"
      :name="phoneProp.name"
      :type="phoneProp.type"
      :value="updatePhone || phoneProp.value"
      :error="errors && errors.loginBuyPhone"
      :required="true"
    />
    <!--        <span class="authentication-phone__error" v-if="errors">{{ errors.loginBuyPhone }}</span>-->
    <EnterCabinetMainBtn :btn-values="messages.smsCode" />
  </form>
</template>

<script>
import { mapState } from 'vuex';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import EnterCabinetMainBtn from '@components/Cabinet/EnterCabinet/EnterCabinetMainBtn.vue';
import Recaptcha3 from '../../../utils/Recaptcha3';

export default {
  name: 'AuthenticationPhone',
  components: { EnterCabinetMainBtn, DefPhone },
  props: ['updatePhone'],
  computed: {
    ...mapState({
      authData: ({ personal }) => personal.data,
      messages: ({ personal }) => personal.data.messages,
      chooseEnter: ({ personal }) => personal.data.chooseEnter,
      btnValues: ({ personal }) => personal.data.btnValues,
      errors: ({ personal }) => personal.data.errors,
    }),
    phoneProp() {
      return this.authData.authInputs.find((el) => el.type === 'text');
    },
  },
  methods: {
    async loginByPhone(e) {
      const reCaptchaToken = await Recaptcha3.getSubmitToken();
      this.$store.dispatch('personal/loginByPhone', { e, component: this, reCaptchaToken });
    },
    // async recaptcha() {
    //     this.$store.dispatch('personal/recaptcha', { component: this });
    // },
  },
};
</script>

<style lang="scss" scoped>
.authentication-phone {
  &__error {
    color: #ff0000;
    font-size: 10px;
  }
  :deep(.def-phone__placeholder) {
    text-transform: none;
  }
}
</style>
